<template>
  <div class="bg-white p-3">
    <div class="d-flex flex-column">
      <p>{{ trans('admin.system_messages.filter_explanation') }}</p>

      <p v-if="userable === 'none'">
        {{ trans('admin.system_messages.filter_login_explanation') }}
      </p>

      <!-- Programs filter -->
      <div
        v-if="userable == 'employee' || userable == 'student'"
        id="programs_filter"
      >
        <input
          id="programs_filter_enabled"
          v-model="filters.programs.enabled"
          type="checkbox"
        >
        <label for="programs_filter_enabled">{{ trans_choice('core.programs', 2) }}</label>

        <div v-if="filters.programs.enabled">
          <VInputWrapper
            name="programs_multi_select"
            :label="trans_choice('core.programs', 2)"
            :errors="getErrors('filters.programs')"
          >
            <multi-select-component
              id="programs_multi_select"
              v-model="filters.programs.params.programs"
              type="program"
              :search-at-mounted="true"
              track-by="name"
              :placeholder="trans_choice('core.programs', 2)"
            />
          </VInputWrapper>
        </div>
      </div>
      <hr>

      <!-- HasPhoto filter -->
      <div
        v-if="userable == 'employee' || userable == 'student'"
        id="has_photo_filter"
      >
        <input
          id="has_photo_filter_enabled"
          v-model="filters.has_photo.enabled"
          type="checkbox"
        >
        <label for="has_photo_filter_enabled">{{ trans_choice('core.photos', 2) }}</label>

        <div v-if="filters.has_photo.enabled">
          <VInputWrapper
            name="has_photo_select"
            :label="trans('admin.system_messages.filters.has_photo.label')"
            :errors="getErrors('filters.has_photo')"
          >
            <select
              id="has_photo_select"
              v-model="filters.has_photo.params.has_photo"
              class="form-control"
            >
              <option :value="true">
                {{ trans('core.yes') }}
              </option>
              <option :value="false">
                {{ trans('core.no') }}
              </option>
            </select>
          </VInputWrapper>
        </div>
      </div>
      <hr>

      <!-- Groups filter -->
      <div
        v-if="userable == 'student'"
        id="groups_filter"
      >
        <input
          id="groups_filter_enabled"
          v-model="filters.in_groups.enabled"
          type="checkbox"
        >
        <label for="groups_filter_enabled">{{ trans_choice('core.groups', 2) }}</label>

        <div v-if="filters.in_groups.enabled">
          <VInputWrapper
            name="groups_multi_select"
            :label="trans_choice('core.groups', 2)"
            :errors="getErrors('filters.in_groups')"
          >
            <multi-select-component
              id="groups_multi_select"
              v-model="filters.in_groups.params.groups"
              type="group"
              :query-options="{ 'withTerm': 1 }"
              :search-at-mounted="true"
              track-by="name"
              :placeholder="trans_choice('core.groups', 2)"
            />
          </VInputWrapper>
        </div>
      </div>
      <hr>

      <!-- Does not have characteristic filter -->
      <div
        v-if="userable == 'student'"
        id="does_not_have_characteristic_filter"
      >
        <input
          id="does_not_have_characteristic_filter_enabled"
          v-model="filters.student_does_not_have_characteristic.enabled"
          type="checkbox"
        >
        <label for="does_not_have_characteristic_filter_enabled">{{ trans('admin.system_messages.filters.does_not_have_characteristic.label') }}</label>

        <div v-if="filters.student_does_not_have_characteristic.enabled">
          <VInputWrapper
            name="student_characteristic_multi_select"
            :label="trans_choice('student.student_characteristics_short', 1)"
            :errors="getErrors('filters.student_does_not_have_characteristic')"
          >
            <multi-select-component
              id="student_characteristic_multi_select"
              v-model="filters.student_does_not_have_characteristic.params.student_characteristic"
              type="student-characteristic"
              :search-at-mounted="true"
              :placeholder="trans('core.type_or_click') + ' ...'"
              :max-selected-options="1"
            />
          </VInputWrapper>
        </div>
      </div>
      <hr>

      <button
        type="button"
        class="btn btn-primary float-right m-2"
        @click="nextStep"
      >
        {{ trans('core.next') }}
      </button>
    </div>
  </div>
</template>

<script>
import MultiSelectComponent from '@/employees/components/FormComponents/MultiSelectComponent'
import { filter } from 'lodash'

export default {
  name: 'SystemMessageFiltersEdit',
  components: { MultiSelectComponent },
  props: {
    value: {
      type: Object,
      required: false,
      default: () => {
        return {
          programs: {
            enabled: false,
            params: {},
          },
          has_photo: {
            enabled: false,
            params: {},
          },
          in_groups: {
            enabled: false,
            params: {},
          },
          student_does_not_have_characteristic: {
            enabled: false,
            params: {},
          },
        }
      },
    },
    userable: {
      type: String,
      required: true,
    },
    isSaving: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    errors: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  data () {
    return {
      filters: {},
    }
  },

  watch: {
    filters: {
      handler: function (value) {
        this.$emit('input', value)
      },
      deep: true,
    },
  },

  beforeMount () {
    this.filters = this.value

    if (this.userable === 'none') {
      this.nextStep()
    }
  },

  methods: {
    nextStep () {
      this.$emit('change-step', 2)
    },

    getErrors (field) {
      const errors = this.errors[field] ?? []

      return errors.map(message => {
        return { message }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-primary {
  background-color: #646B78 !important;
}
</style>
